import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import { useDepthChart } from "../../../../contexts/DepthChartContext";
import { PlayerSelection } from "../Components/PlayerSelection";
import { useLogger } from "../../../../contexts/LoggerContext";
import { RosterPlayer } from "../../../../types/LogTypes";
import { useRoster } from "../../../../contexts/RosterContext";
import { GainLossInput } from "../Components/GainLossInput";

export const OffensePassLog = () => {
  const [gainLoss, setGainLoss] = useState(0);
  const [selectedReceiver, setSelectedReceiver] = useState<RosterPlayer | null>(
    null
  );
  const [selectedPasser, setSelectedPasser] = useState<RosterPlayer | null>(
    null
  );
  const [jerseyNumberPasser, setJerseyNumberPasser] = useState<string>("");
  const [jerseyNumberReceiver, setJerseyNumberReceiver] = useState<string>("");
  const { receivers, quarterbacks } = useDepthChart();
  const { setCurrentPlayLog, clearSelections } = useLogger();
  const { rosterPlayers } = useRoster();

  const findReceiver = (jerseyNumber: string) => {
    return rosterPlayers.find(
      (player) => player.jersey_number?.toString() === jerseyNumber
    );
  };

  const findPasser = (jerseyNumber: string) => {
    return rosterPlayers.find(
      (player) => player.jersey_number?.toString() === jerseyNumber
    );
  };

  const handleJerseyNumberPasserChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 99)) {
      setJerseyNumberPasser(value);
      const player = findPasser(value);
      if (player) {
        setSelectedPasser(player);
      }
    }
  };
  const handleJerseyNumberReceiverChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 99)) {
      setJerseyNumberReceiver(value);
      const player = findReceiver(value);
      if (player) {
        setSelectedReceiver(player);
      }
    }
  };

  const handleReceiverSelection = (player: RosterPlayer) => {
    setSelectedReceiver(player);
    setJerseyNumberReceiver(player.jersey_number?.toString() || "");
  };

  const handlePasserSelection = (player: RosterPlayer) => {
    setSelectedPasser(player);
    setJerseyNumberPasser(player.jersey_number?.toString() || "");
  };

  useEffect(() => {
    if (selectedPasser) {
      setCurrentPlayLog({
        passer_roster_player: selectedPasser,
        receiver_roster_player: selectedReceiver || undefined,
        gain_loss: gainLoss,
      });
    }
  }, [selectedPasser, selectedReceiver, gainLoss]);

  useEffect(() => {
    if (clearSelections) {
      setSelectedReceiver(null);
      setJerseyNumberReceiver("");
      setSelectedPasser(null);
      setJerseyNumberPasser("");
      setGainLoss(0);
    }
  }, [clearSelections]);

  return (
    <Box>
      <Grid container spacing={2}>
        {/* Player Selectors */}
        <Grid item xs={12} md={8}>
          <Box
            style={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <PlayerSelection
              title="Passer"
              players={quarterbacks}
              selectedPlayer={selectedPasser}
              jerseyNumber={jerseyNumberPasser}
              maxDisplayedPlayers={5}
              handlePlayerSelection={handlePasserSelection}
              handleJerseyNumberChange={handleJerseyNumberPasserChange}
            />

            <PlayerSelection
              title="Receiver"
              players={receivers}
              selectedPlayer={selectedReceiver}
              jerseyNumber={jerseyNumberReceiver}
              maxDisplayedPlayers={8}
              handlePlayerSelection={handleReceiverSelection}
              handleJerseyNumberChange={handleJerseyNumberReceiverChange}
            />
          </Box>
        </Grid>

        {/* Gain/Loss */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              minHeight: "300px",
            }}
          >
            <GainLossInput
              value={gainLoss}
              onChange={setGainLoss}
              label="Gain/Loss"
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
